import { useEffect, useState } from "react";
import { api, apiError, fmtDate } from "./api";
import { Card, PageHead, Pill, Select, Empty } from "./widgets";
import { toast } from "sonner";

const STATUSES = ["requested", "confirmed", "reschedule", "completed", "cancelled"];

const Consultations = () => {
  const [items, setItems] = useState(null);

  const load = () => api.get("/admin/consultations").then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => {
    load();
  }, []);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/consultations/${id}`, { status });
      toast.success("Status updated.");
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <div data-testid="consultations-page">
      <PageHead title="Consultations" sub="Consultation requests from the website. Scheduling integrations (Calendly, Google Calendar) can attach here later." />
      {!items ? (
        <p className="text-sm text-[#171717]/50">Loading…</p>
      ) : items.length === 0 ? (
        <Empty>No consultation requests yet.</Empty>
      ) : (
        <>
          {/* Mobile: card list */}
          <div className="space-y-3 lg:hidden">
            {items.map((c) => (
              <Card key={c.id} data-testid={`consultation-card-${c.id}`}>
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <p className="text-sm text-[#171717]">{c.name}</p>
                    <p className="mt-1 break-all text-xs text-[#171717]/50">{c.email}</p>
                    <p className="text-xs text-[#171717]/50">{c.phone}</p>
                  </div>
                  <Pill tone="champagne">{c.status}</Pill>
                </div>
                <p className="mt-3 text-xs text-[#171717]/60">{c.service} · {c.consultationType}</p>
                <p className="mt-1 text-xs text-[#171717]/60">Requested: {c.preferredDate || "—"} {c.preferredTime || ""}</p>
                <p className="mt-1 text-xs text-[#171717]/45">Submitted {fmtDate(c.createdAt)}</p>
                <Select className="mt-3 w-full" value={c.status} onChange={(e) => setStatus(c.id, e.target.value)} data-testid={`consultation-status-mobile-${c.id}`}>
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </Select>
              </Card>
            ))}
          </div>

          {/* Desktop: full table */}
          <Card className="hidden overflow-x-auto p-0 lg:block">
            <table className="w-full min-w-[860px] text-sm">
            <thead>
              <tr className="border-b border-[#171717]/10 text-left text-[0.6rem] uppercase tracking-[0.16em] text-[#171717]/45">
                <th className="px-5 py-3.5 font-medium">Client</th>
                <th className="px-5 py-3.5 font-medium">Service</th>
                <th className="px-5 py-3.5 font-medium">Type</th>
                <th className="px-5 py-3.5 font-medium">Requested</th>
                <th className="px-5 py-3.5 font-medium">Submitted</th>
                <th className="px-5 py-3.5 font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-b border-[#171717]/5 hover:bg-[#F4F0E8]/60" data-testid={`consultation-${c.id}`}>
                  <td className="px-5 py-3.5">
                    <p className="text-[#171717]">{c.name}</p>
                    <p className="text-xs text-[#171717]/50">{c.email} · {c.phone}</p>
                  </td>
                  <td className="px-5 py-3.5 text-xs text-[#171717]/60">{c.service}</td>
                  <td className="px-5 py-3.5 text-xs text-[#171717]/60">{c.consultationType}</td>
                  <td className="px-5 py-3.5 text-xs text-[#171717]/60">{c.preferredDate || "—"} {c.preferredTime || ""}</td>
                  <td className="px-5 py-3.5 text-xs text-[#171717]/55">{fmtDate(c.createdAt)}</td>
                  <td className="px-5 py-3.5">
                    <Select value={c.status} onChange={(e) => setStatus(c.id, e.target.value)} data-testid={`consultation-status-${c.id}`}>
                      {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                    </Select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
        </>
      )}
    </div>
  );
};

export default Consultations;
